import axios from 'axios'
import { Toast, Dialog } from 'vant';

const TIMEOUT = 30000
const BASE_URL = 'https://www.buqixia.com'


const service = axios.create({
    baseURL: BASE_URL,
    timeout: TIMEOUT,
})

service.interceptors.request.use(config => {
    const token = localStorage.getItem('TOKEN')
    if (token) {
        config.headers.token = token
    }
    return config
})

service.interceptors.response.use(response => {
    const data = response.data
    try {
        if (data.code === 200) {
            return data
        } else {
            const message = data.msg
            if (message) {
                Dialog.alert({
                    title: "提示",
                    message: message,
                    confirmButtonText: "好的",
                })
            } else {
                Dialog.alert({
                    title: "提示",
                    message: '系统异常，请稍后再试!',
                    confirmButtonText: "好的",
                })
            }

            return Promise.reject(data)
        }
    } catch (e) {
        Dialog.alert({
            title: "提示",
            message: '系统异常，请稍后再试!',
            confirmButtonText: "好的",
        })
    }

}, error => {
    try {
        const message = error.response.data.msg
        if (message) {
            // Toast.fail(message)
        } else {
            Dialog.alert({
                title: "提示",
                message: '系统异常，请稍后再试!',
                confirmButtonText: "好的",
            })
        }

        return Promise.reject(error)
    } catch (e) {
        Dialog.alert({
            title: "提示",
            message: '系统异常，请稍后再试!',
            confirmButtonText: "好的",
        })
    }

})

export default service